import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import { setLoading, saveData } from './actions';
import OrderDetails from './component';
import ClipboardJS, { copy } from 'clipboard';



class OrderDetailsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      issueType: "Vending Failed",
      button_copy: false
    };
  }

  handleIssueChange = (e, data) => {
    this.setState((props) => {
      return {
        issueType: data.value,
        button_copy: false
      };
    })

  }
  
  onClickOfAddToSheet = () => {
    // console.log("button Clicked", this.state.issueType)
    const current = new Date();
    const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
    const mobile = this.props.orderDetails.details.order.map((el) => el.orderMobile)[0]
    var a = this.props.orderDetails.details.paymentDetails.map((el) => (el[Object.keys(el)[Object.keys(el).length-2]]))
    if(a[1] === 'REFUNDED_BACK'){
      var refundStatus = 'AR'
    }
    else {
      var refundStatus = 'MR'
    }
    const orderID = this.props.match.params.orderId
    const vmID = this.props.orderDetails.details.order.map((el) => el.orderVM)[0]
    const agent = JSON.parse(localStorage.data).details.userDetails.full_name
    const text = '={"'+date+'","'+mobile+'","'+this.state.issueType+'","Done","'+refundStatus+'","'+orderID+'","'+vmID+'","'+agent+'"}'
    // console.log(text)
    
    ClipboardJS.copy(text)
    this.setState((props) => {
      return {
        button_copy: true
      };
    })
    
  };

  componentDidMount() {
    // fetch all the permissions
    this.props.setLoading(true);

    const orderId = this.props.match.params.orderId;
    // alert(orderId);
    if (!orderId) {
      toastr.error('ERROR', 'Invalid Order Id');
      return this.props.history.push('/orders');
    }

    this.props.getDataFromAPI(
      `/orders/fulldetails/${orderId}`,
      'GET',
      undefined,
      (response) => {
        this.props.saveData(response);
        this.props.setLoading(false);
      },
      (err) => {
        this.props.setLoading(false);
        toastr.error('ERROR', err.data.message);
        // console.log(err);
      },
      true
    );
  }

  render() {
    // const details =
    //   this.props.orderDetails && this.props.orderDetails.details && this.props.orderDetails.details;
    const loading = this.props.orderDetails && this.props.orderDetails.loading;
    const orderId = this.props.match.params.orderId;
    const popUp_style = {
      borderRadius: '2%',
      padding: '2em',
      width: '300px'
    }
    const button_copy = this.state.button_copy

    // console.log('order detailsfulldetails page ----------->', this.props.orderDetails);
    // console.log('THISSSS' , orderDetails)
    return <OrderDetails 
      orderId={orderId} 
      loading={loading} 
      details={this.props.orderDetails} 
      onClickOfAddToSheet={this.onClickOfAddToSheet}
      popUp_style={popUp_style}
      handleIssueChange={this.handleIssueChange}
      button_copy={button_copy}
      />;
  }
}

function mapStateToProps({ orderDetails }) {
  return {
    orderDetails,
    
  };
}

export default withRouter(connect(mapStateToProps, {
  getDataFromAPI,
  setLoading,
  saveData
})(OrderDetailsContainer));



// WEBPACK FOOTER //
// ./src/Modules/OrdersDetails/container.jsx